<template>
  <div>
    <b-card v-if="Object.keys(OrgInformation).length>0 && (OrgInformation.data.board_members_count === 0 || OrgInformation.data.board_members_count === null )">
      <alert
        :massage="`لا يمكنك إضافة أعضاء قبل أن يتم تحديد عدد أعضاء مجلس ${councilType} `"
        class="w-100 mx-1"
      ></alert>
    </b-card>
    <b-card v-else>
      <div class="d-flex align-items-center justify-content-end">
        <span
            :title="
              (Object.keys(OrgInformation).length>0 && OrgInformation.data.board_members_count<= memberCount)
                ? `لا يمكن إضافة أكثر من ${Object.keys(OrgInformation).length>0 ? OrgInformation.data.board_members_count : ''} عضو`
                : ''
            "
            v-b-tooltip.hover.v-warning.bottom
          >
            <b-button
              variant="success"
              @click="onAddClicked"
              v-if="canAddTransaction"
              :disabled="Object.keys(OrgInformation).length>0 ? OrgInformation.data.board_members_count<= memberCount: false"
              v-can="{ slug: $route.meta.slug, action: 'C' }"
              
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              إضافة
            </b-button>
          </span>
      </div>
      <hr />
      <data-table
        ref="membersTable"
        :ep="`v2/director-boards/administrative/${id}?type=administrative`"
        :fields="fields"
        v-can="{ slug: $route.meta.slug, action: 'S' }"
        dataPath="data"
      >
      <template #cell(oldDirector)="row">
        <span v-if="row.item.oldDirector">
          {{row.item.oldDirector}}
          </span>
          <span v-else>
             -
          </span>
        </template>
      <template #cell(switching_reason)="row">
        <span v-if="row.item.switching_reason">
          {{ row.item.switching_reason }}
          </span>
          <span v-else>
             -
          </span>
        </template>
        
        <template #cell(dob)="{ value }">
          {{ $moment(value).format("YYYY-MM-DD") }}
        </template>
        
        <template #cell(inquiry_bulletin_file)="{ value }" >
          
          <b-button
            size="sm"
            @click="$router.push({ name: 'file-view', query: { ep: value } })"
            variant="flat-success"
          >
            <feather-icon class="mx-25" icon="EyeIcon" />
            عرض الملف
          </b-button>
        </template>
        <template #cell(actions)="row">
          <div class="d-flex justify-content-between align-items-center">
            <b-dropdown
              variant="link"
              v-if="canAddTransaction"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <b-dropdown-item
                v-can="{ slug: $route.meta.slug, action: 'U' }"
                @click="onUpdateClicked(row.item)"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">تعديل</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-can="{ slug: $route.meta.slug, action: 'D' }"
                @click="onDelete(row.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">حذف</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
      </data-table>
      <form-modal
        ref="memberModal"
        :formSchema="membersFormSchema"
        title="معلومات العضو"
        v-model="formModal"
        :loading="loading"
        @confirm="onModalConfirmed"
        static
      >
      <template #job_title_id="{ form }">
        <form-select
          label="الصفة"
          :getOptionLabel="(x) => x.name"
          :reduce="(x) => x.id"
          id="job_title_id"
          :ep="`v2/selects/job-title-by-director-boards/${id}?slug=${action}`"
          ref="job_title_id"
          rules="required"
          v-model="form.job_title_id"
        />
      </template>
      
      </form-modal>
    </b-card>
  </div>
</template>

<script>
import dataTable from "@/components/data-table";
import FormSelect from "@/components/form-select";
import FormFileInput from "@/components/FormFileInput.vue";
import {
  BButton,
  BCard,
  BBadge,
  BDropdown,
  BDropdownItem,
  VBTooltip,
} from "bootstrap-vue";
import FormModal from "@/components/FormModal.vue";
import { mapActions, mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Alert from "@/components/Alert.vue";

export default {
  mounted() {
    this.fetchOrgInformation()
    this.fetchMemberCount({id : this.id , type : 'administrative'})
  },
  data() {
    return {
      action : 'C' ,
      ep : '',
      job_title_id : null,
      formModal: false,

      membersFormSchema: {
        name: {
          component: "FormInput",
          key: "name",
          attrs: {
            label: "الاسم الكامل",
            rules: "required",
          },
        },
        qualification_id: {
          component: "FormSelect",
          key: "qualification_id",
          attrs: {
            id: "qualification",
            label: "المؤهل العلمي",
            rules: "required",
            ep: "v2/selects/qualifications",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.title,
          },
        },
        job_title_id: {
          key: "job_title_id",
        },
        phone_number: {
          component: "FormCleave",
          key: "phone_number",
          attrs: {
            label: " رقم الموبايل",
            isNumber: true,
            charsCount: 10,
          },
        },
        dob: {
          component: "FormMask",
          key: "dob",
          attrs: {
            label: "تاريخ الميلاد",
            options: "date",
            rules: "required",
            placeholder: "YYYY-MM-DD",
          },
        },
        ID_number: {
          component: "FormCleave",
          key: "ID_number",
          attrs: {
            label: "الرقم الوطني",
            isNumber: true,
            charsCount: 11,
          },
        },
        
        inquiry_bulletin_file: {
          key: "inquiry_bulletin_file",
          component: "FormFileInput",   
          rules: "required",
          attrs: {
            label: "نشرة الإستعلام",
            accept: ".pdf",
            rules: "required",
          },
        },
      },

      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        { key: "name", label: "الاسم" },
        { key: "qualification.title", label: "المؤهل العلمي" },
        {
          key: "jobTitle.name",
          label: "الصفة",
        },
        {
          key: "phone_number",
          label: "رقم الموبايل",
        },
        {
          key: "ID_number",
          label: "الرقم الوطني",
        },
        {
          key: "dob",
          label: "تاريخ الميلاد",
        },
        {
          key: "inquiry_bulletin_file",
          label: "نشرة الإستعلام",
        },
        {
          key: "oldDirector",
          label: "العضو المُستبدل به",
        },
        {
          key: "switching_reason",
          label: "سبب الإستبدال ",
        },
        { key: "actions", label: " " },
      ],
    };
  },
  components: {
    dataTable,
    BDropdown,
    BDropdownItem,
    BButton,
    BCard,
    BBadge,
    FormModal,
    FormSelect,
    FormFileInput,
    Alert
  },
  props: ["id"],
  directives: {
    "b-tooltip": VBTooltip,
  },
  watch: {
    action(val) {
      console.log('val' , val)
      if (this.$refs.job_title_id) {

        if(val === 'C') this.$refs.job_title_id.refreshOptions(`v2/selects/job-title-by-director-boards/${this.id}?slug=${this.action}`);
        else this.$refs.job_title_id.refreshOptions(`v2/selects/job-title-by-director-boards/${this.id}?slug=${this.action}&jobTitleId=${this.job_title_id}`);
      }
    },
  },
  methods: {
    ...mapActions("AdministrativeStatus", [
      "addMember",
      "updateMember",
      "deleteMember",
      "fetchMemberCount"
    ]),
    
    ...mapActions("AdministrativeStatus/Transactions/Transactions", ["fetchOrgInformation"]),
  
    onUpdateClicked(form) {
      this.action = 'U'
      var toUpdate = {
        id: form.id,
        name: form.name,
        qualification_id: form.qualification.id,
        job_title_id: form.jobTitle.id,
        phone_number: form.phone_number,
        dob: form.dob,
        ID_number: form.ID_number,
        inquiry_bulletin_file: form.inquiry_bulletin_file,
      };
      this.job_title_id = form.jobTitle.id
      this.$refs.memberModal.init(toUpdate);
      this.formModal = true;
    },
    onAddClicked() {
      this.action = 'C'
      this.job_title_id = null
      this.$refs.memberModal.init({});
      this.formModal = true;
    },
    onDelete(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف العضو؟", {
          title: "تأكيد حذف العضو",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteMember({ id, type: "administrative" }).then(() => {
              this.$refs.membersTable.refreshTable();
              this.fetchMemberCount({id : this.id , type : 'administrative'})
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "تم الحذف بنجاح",
                  icon: "CheckSquareIcon",
                  variant: "success",
                },
              });
            });
        });
    },

    async onModalConfirmed(form) {
      if (form.id)
        await this.updateMember({
          type: "administrative",
          form: { ...form, director_board_id: this.id },
        }).then(() => {
          this.$refs.membersTable.refreshTable();
          this.fetchMemberCount({id : this.id , type : 'administrative'});
          this.job_title_id = null
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تم تعديل معلومات العضو بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        });
      else
        await this.addMember({
          type: "administrative",
          form: { ...form, director_board_id: this.id },
        }).then(() => {
          this.$refs.membersTable.refreshTable();
          this.fetchMemberCount({id : this.id , type : 'administrative'});
          this.job_title_id =null
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "تمت إضافة العضو بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        });

      this.formModal = false;
    },
  },
  computed: {
    ...mapGetters("AdministrativeStatus", ["loading" , "memberCount"]),
    ...mapGetters("AdministrativeStatus/Transactions/Transactions", ["OrgInformation"]),
    ...mapGetters("NgoProfile", [ "canAddTransaction"]),
    
    councilType() {
      return this.OrgInformation.members_type === true ? "الإدارة" : this.OrgInformation.members_type === false ? "الأمناء" : "";
    },
    
  },
};
</script>
